import sofia from '../assets/Sofía Karstegl.png';
import barbara from '../assets/Barbara Zamora.png';
import caterina from '../assets/Caterina Mela.png';

export const teamData = [
  {
    id: 1,
    name: "Sofía Kastegl",
    role: "Fonoaudióloga Infantil",
    specialty: "Fonoaudióloga",
    bio: "Egresada de la Pontificia Universidad Católica de Chile. Especialista en  Autismo, Atención Temprana, Rechazo Alimentario, Apraxia del Habla Infantil y Motricidad Orofacial, y está formada en metodologías TEACH y ABA. Certificada para la aplicación del test ADOS-2.  Actualmente se encuentra en proceso de certificación en Integración Sensorial.",
    image: sofia,
    icon: "🧠",
    socialMedia: {
      instagram: {
        handle: "@sofi_fono",
        url: "https://www.instagram.com/sofi_fono?igsh=MTdpZnlzcTNzbjMybA=="
      }
    }
  },
  {
    id: 2,
    name: "Barbara Zamora",
    role: "Terapeuta Ocupacional Infanto Juvenil",
    specialty: "Terapeuta Ocupacional",
    bio: "Egresada de la Universidad de los Andes (2019) especialista en Trastorno del Espectro Autista, Dificultades del Procesamiento Sensorial, Dificultades Conductuales y Trastornos del Neurodesarrollo. Certificada en Integración Sensorial, Certificada para la aplicación ADOS-2 y ADI-R, formación en regulación emocional bajo el método Conscious Discipline, Selectividad Alimentaria y Estimulación Temprana.",
    image: barbara,
    icon: "🗣️",
    socialMedia: {
      instagram: {
        handle: "@tobarbarazamora",
        url: "https://www.instagram.com/tobarbarazamora?igsh=MWh5bjJtaWs2NHM4dw=="
      },
      website: {
        url: "https://www.tobarbarazamora.cl/"
      }
    }
  },
  {
    id: 3,
    name: "Caterina Mela",
    role: "Fonoaudióloga Infantil",
    specialty: "Fonoaudióloga",
    bio: "Egresada de la Universidad Andrés Bello (2020), especialista en niños/as y adolescentes con alteraciones del neurodesarrollo y adultos. Trabaja con Habla, Lenguaje, Deglución y Cognición. Certificada en TEA, Atención Temprana, TDL, Lectoescritura, IDTEL, Selectividad Alimentaria y Lavado de Oídos. Asesora en Lactancia.",
    image: caterina,
    icon: "🎯",
    socialMedia: {
      instagram: {
        handle: "@fono.catemela",
        url: "https://www.instagram.com/fono.catemela?igsh=MXVzZWk5cDczZDdw"
      }
    }
  }
];
